<template>
  <el-dialog
    title=""
    :visible.sync="showInvite"
    class="invite-wrapper"
    :before-close="goBack"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    width="400px"
  >
    <div class="invite">
      <div class="top">
        <img class="top-title" src="./img/yaoqing_wenzi.png" alt="" />
      </div>
      <div class="invite-content">
        <gift-pack-item :giftType="1" :ruleNum="1" :finishNum="invite_num > 1 ? 1 : invite_num" :isReceive="invite1_eward" @updateGift="updateGift" />
        <gift-pack-item :giftType="2" :ruleNum="5" :finishNum="invite_num > 5 ? 5 : invite_num" :isReceive="invite2_eward" @updateGift="updateGift" />
        <gift-pack-item
          :giftType="3"
          :ruleNum="10"
          :finishNum="invite_num > 10 ? 10 : invite_num"
          :isReceive="invite3_eward"
          @updateGift="updateGift"
        />
        <div class="rule-content">
          <div class="rule-title">活动规则</div>
          <p class="rule-item">
            1.活动内容：活动期间用户登录账户，分享链接邀请好友注册并观看直播5分钟，即可完成活动任务并获得任务奖励。（可重复完成单人并获取奖励）
          </p>
          <p class="rule-item">2.任务奖励内容：邀请奖励：邀请新人注册（鹰钻：5个、来个角球：2个、666：2个）</p>
          <p class="rule-item">
            成就奖励：邀请注册达成5人（鹰钻：20个、来个角球：10个、666：10个）；邀请注册达成10人（鹰钻：50个、来个角球：10个、666：10个、再进一球：2个）
          </p>
          <p class="rule-item">3.奖励发放时间：新用户完成任务后，在任务界面领取奖励，任务奖励将在5分钟内自动发放到您的账户。</p>
          <p class="rule-item mt-20">补充说明：</p>
          <p class="rule-item">1.本活动仅可通过猎鹰直播官方网站参与。（详情请参考：猎鹰直播用户服务协议）</p>
          <p class="rule-item">
            2.如遇用户通过非正常手段获取活动奖励，猎鹰直播有权取消活动资格，并收回已发放的奖励。（详情请参考：猎鹰直播用户服务协议）
          </p>
          <p class="rule-item">3.活动最终解释权归猎鹰直播所有。</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { post } from "../../util/http";
import GiftPackItem from "./gift-pack-item.vue";
export default {
  components: {
    GiftPackItem,
  },
  props: {
    showInvite: {
      type: Boolean,
      default: false,
    },
    inviteInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    inviteInfo: {
      handler(o, n) {
        const { invite1_eward, invite2_eward, invite3_eward, invite_num } = n || {};
        this.invite1_eward = invite1_eward;
        this.invite2_eward = invite2_eward;
        this.invite3_eward = invite3_eward;
        this.invite_num = invite_num;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      invite1_eward: 2,
      invite2_eward: 2,
      invite3_eward: 2,
      invite_num: 0,
    };
  },
  methods: {
    goBack() {
      this.$emit("closeInvite");
    },
    updateGift(id) {
      post({
        url: "/api/activity/receiveRewards",
        data: { id },
      }).then(({ data }) => {
        if (data.status === 0) {
          this.$emit("showToast", "领取成功");
        }
        this.$emit("updateUserBag");
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
/deep/ {
  .el-dialog {
    border: 8px;
    overflow: hidden;
    border-radius: 10px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    z-index: 10;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
    background: rgba(0, 0, 0, 0.6);
    padding: 3px;
    border-radius: 50%;
    font-size: 18px;
    font-weight: 900;
  }
  .el-dialog__body {
    padding: 0;
    background-image: linear-gradient(180deg, #ff9735 0%, #ffb22f 100%);
    box-shadow: inset 0px 2px 0px 0px rgba(255, 255, 255, 0.1);
  }
}
.invite-wrapper {
  .invite {
    // width: 400px;
    border-radius: 16px;
    position: relative;
    margin: 0 auto;

    .back {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 20px;
      right: 20px;
      border: 1px solid #fff;
      border-radius: 50%;
      color: #fff;
      font-size: 24px;
      text-align: center;
      line-height: 30px;
      z-index: 3007;
      cursor: pointer;
    }

    .top {
      width: 100%;
      height: 350px;
      background: url("./img/yaoqing_beijing.png") no-repeat;
      background-size: contain;
      position: relative;
      border-radius: 16px 16px 0 0;
    }

    .top-title {
      width: 317px;
      position: absolute;
      top: 220px;
      left: 50%;
      transform: translateX(-50%);
    }

    .invite-content {
      width: 100%;
      padding: 0 24px 16px;
    }

    .rule-content {
      width: 100%;
      margin-top: 28px;
      padding: 44px 16px 16px;
      background: #ffe4b9;
      box-shadow: 0px 2px 6px 0px rgba(189, 116, 0, 0.4);
      border-radius: 8px;
      position: relative;
    }

    .rule-title {
      width: 150px;
      height: 48px;
      background: url("./img/yaoqing_guize.png") no-repeat;
      background-size: cover;
      font-size: 16px;
      color: #ffffff;
      font-weight: 600;
      text-align: center;
      line-height: 40px;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }

    .rule-item {
      width: 100%;
      font-size: 14px;
      color: #794e12;
      line-height: 20px;
    }

    .mt-20 {
      margin-top: 20px;
    }
  }
}
</style>
